import { render } from "./InStoreOrderHistoryPage.vue?vue&type=template&id=418e5250"
import script from "./InStoreOrderHistoryPage.vue?vue&type=script&lang=js"
export * from "./InStoreOrderHistoryPage.vue?vue&type=script&lang=js"

import "./InStoreOrderHistoryPage.vue?vue&type=style&index=0&id=418e5250&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__